import 'swiper/swiper.min.css';

import React, { useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { translate } from 'react-i18next';

import CardWithImageInArc from '../Card/CardWithImageInArc';
import PropTypes from 'prop-types';
import { media } from '../../styles/media';
import styled from 'styled-components';

import 'swiper/modules/pagination/pagination.min.css';

const SliderWrapper = styled(Swiper)`
  width: 100%;
  overflow: unset !important;
  position: relative !important;
  z-index: 3 !important;

  .swiper-slide {
    height: auto;
  }

  .swiper-pagination {
    width: 150px !important;
    bottom: -25px !important;
  }

  .swiper-pagination-bullet {
    width: 12px;
    height: 2px;
    border-radius: 0px;
    background-color: ${({ theme }) => theme.color.brand.lightGrey2};
    transition: all 0.3s ease !important;
    opacity: 1;
    transform: scale(1) !important;
  }

  .swiper-pagination-bullet-active {
    width: 42px;
    background-color: ${({ theme }) => theme.color.brand.accent};
  }
`;

const SlideWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;

  ${media.tablet`
    display: block;
  `};
`;

const OfferSlidesCarousel = ({ slides, isMobile, centerSlides, t }) => {
  const enableSwipe = useMemo(() => isMobile || slides.length > 3, [isMobile]);

  return (
    <SliderWrapper
      initialSlide={isMobile ? 0 : 1}
      slidesPerView={isMobile ? 1 : 'auto'}
      spaceBetween={50}
      modules={[Pagination]}
      pagination={{
        enabled: enableSwipe,
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 1
      }}
      centeredSlides={centerSlides ?? !isMobile}
      allowSlideNext={enableSwipe}
      allowSlidePrev={enableSwipe}
    >
      {slides.map((slide, index) => {
        const { detail } = slide;

        const buttonUrl = detail.cta_url
          ? detail.cta_url
          : slide.shop_id
            ? `${t('common:brands.navigation.brands')}/${slide?.shop?.type ||
                'unknown'}/${slide?.shop?.category?.detail?.slug ||
                'uncategorized'}/${slide.shop.slug}`
            : `page/${slide.pageBuilder.detail.slug}`;

        const labelUrl = detail.cta_label || t('common:button.discover');

        let logoUrl;
        if (slide?.shop) {
          logoUrl = slide?.shop?.logo2Desk;
        } else if (slide?.pageBuilder) {
          const timeBlock = slide?.pageBuilder?.blocks?.find(
            b => b.type === 'time_block'
          );
          logoUrl = timeBlock?.img_desktop || timeBlock?.img_mobile;
        }

        const slideDetail = {
          title: detail?.title,
          description: detail?.description,
          date: detail?.offer_date,
          image: {
            url: slide.image,
            alt: detail?.title,
            height: isMobile ? 305 : 360,
            width: isMobile ? 305 : 360
          },
          logo: {
            url: logoUrl || null,
            alt: detail?.title
          },
          ctaLeft: {
            label: labelUrl,
            url: buttonUrl
          }
        };

        return (
          <SwiperSlide
            key={`event-slide-${index}`}
            style={{
              maxWidth: isMobile ? 'unset' : '360px'
            }}
          >
            <SlideWrapper>
              <CardWithImageInArc
                card={slideDetail}
                maxWidth={isMobile ? 305 : 360}
                minWidth={isMobile ? 305 : 360}
                fullHeight
              />
            </SlideWrapper>
          </SwiperSlide>
        );
      })}
    </SliderWrapper>
  );
};

OfferSlidesCarousel.propTypes = {
  slides: PropTypes.array,
  isMobile: PropTypes.bool,
  t: PropTypes.func,
  i18n: PropTypes.object,
  centerSlides: PropTypes.bool
};

export default translate()(OfferSlidesCarousel);
